"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import SafeManagement from "@/views/safemanagements/SafeManagement.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import MainView from "@/components/layout/MainView.vue";
import InprogressShops from "@/views/safemanagements/InprogressManager/components/InprogressShops.vue";
import InprogressUser from "@/views/safemanagements/InprogressManager/components/InprogressUser.vue";
import EarlyWarningSettings from "@/views/safemanagements/InprogressManager/components/EarlyWarningSettings.vue";
import RegulatorySettings from "@/views/safemanagements/InprogressManager/components/RegulatorySettings.vue";
import MonitorLog from "@/views/safemanagements/InprogressManager/components/MonitorLog.vue";
import WebResourceRequestList from "@/views/safemanagements/InprogressManager/components/WebResourceRequestList.vue";
import _ from "lodash";
import i18n from "@/lang";
const UUID = require("uuid");
import UiMenuBar, {
  MenuController
} from "@/components/menu/ManagerMenuBar.vue";
import API from "@ym-framework/api-utils";
let InprogressManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "inprogress_account",
          name: i18n.t("safe_management.inprogress_manage_account"),
          icon_image: "safety_sidebar_6"
        },
        {
          index: "inprogress_shops",
          name: i18n.t("safe_management.inprogress_manage_shop"),
          icon_image: "safety_sidebar_6"
        },
        {
          index: "early_warning",
          name: i18n.t("safe_management.early_warning"),
          icon_image: "log_sidebar_3"
        },
        {
          index: "regulatory_settings",
          name: i18n.t("sage_management.regulatory_settings"),
          icon_image: "account_sidebar_2"
        },
        {
          index: "monitor_log",
          name: i18n.t("safe_management.process_monitor_log"),
          icon_image: "log_sidebar_5"
        },
        {
          index: "web_resource_request_list",
          name: i18n.t("safe_management.request_list"),
          icon_image: "safety_sidebar_1",
          sub_menus: [
            {
              index: "apply",
              name: i18n.t("safe_management.wait_pass")
            },
            {
              index: "approve",
              name: i18n.t("safe_management.team_pass_sidebar")
            },
            {
              index: "reject",
              name: i18n.t("safe_management.team_refuse_sidebar")
            }
          ]
        }
      ],
      "inprogress_shops",
      ["web_resource_request_list"]
    );
    this.default_components = "";
    this.mumber_autid_key = "";
    this.regulationMode = "SHOP";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$session.type === "account") {
        yield this.getSettings();
        if (this.regulationMode === "USER") {
          this.menu_controller = new MenuController(
            false,
            [
              {
                index: "inprogress_account",
                name: i18n.t(
                  "safe_management.inprogress_manage_account"
                ),
                icon_image: "safety_sidebar_6"
              },
              {
                index: "early_warning",
                name: i18n.t("safe_management.early_warning"),
                icon_image: "log_sidebar_3"
              },
              {
                index: "regulatory_settings",
                name: i18n.t("sage_management.regulatory_settings"),
                icon_image: "account_sidebar_2"
              },
              {
                index: "monitor_log",
                name: i18n.t("safe_management.process_monitor_log"),
                icon_image: "log_sidebar_5"
              },
              {
                index: "web_resource_request_list",
                name: i18n.t("safe_management.request_list"),
                icon_image: "safety_sidebar_1",
                sub_menus: [
                  {
                    index: "apply",
                    name: i18n.t("safe_management.wait_pass")
                  },
                  {
                    index: "approve",
                    name: i18n.t("safe_management.team_pass_sidebar")
                  },
                  {
                    index: "reject",
                    name: i18n.t("safe_management.team_refuse_sidebar")
                  }
                ]
              }
            ],
            "inprogress_account",
            ["web_resource_request_list"]
          );
          this.default_components = "inprogress_account";
        } else {
          this.menu_controller = new MenuController(
            false,
            [
              {
                index: "inprogress_shops",
                name: i18n.t("safe_management.inprogress_manage_shop"),
                icon_image: "safety_sidebar_6"
              },
              {
                index: "early_warning",
                name: i18n.t("safe_management.early_warning"),
                icon_image: "log_sidebar_3"
              },
              {
                index: "regulatory_settings",
                name: i18n.t("sage_management.regulatory_settings"),
                icon_image: "account_sidebar_2"
              },
              {
                index: "monitor_log",
                name: i18n.t("safe_management.process_monitor_log"),
                icon_image: "log_sidebar_5"
              },
              {
                index: "web_resource_request_list",
                name: i18n.t("safe_management.request_list"),
                icon_image: "safety_sidebar_1",
                sub_menus: [
                  {
                    index: "apply",
                    name: i18n.t("safe_management.wait_pass")
                  },
                  {
                    index: "approve",
                    name: i18n.t("safe_management.team_pass_sidebar")
                  },
                  {
                    index: "reject",
                    name: i18n.t("safe_management.team_refuse_sidebar")
                  }
                ]
              }
            ],
            "inprogress_shops",
            ["web_resource_request_list"]
          );
          this.default_components = "inprogress_shops";
        }
      } else {
        if (this.$session.permissions.any("SHOW_ALL_MENUS", "IN_PROCESS_MONITORING_SETTING")) {
          yield this.getSettings();
        }
        this.menu_controller = new MenuController(
          false,
          [
            ...(() => {
              if (this.$session.permissions.any("SHOW_ALL_MENUS", "IN_PROCESS_MONITORING_SETTING")) {
                if (this.regulationMode === "USER") {
                  return [
                    {
                      index: "inprogress_account",
                      name: i18n.t(
                        "safe_management.inprogress_manage_account"
                      ),
                      icon_image: "safety_sidebar_6"
                    },
                    {
                      index: "early_warning",
                      name: i18n.t("safe_management.early_warning"),
                      icon_image: "log_sidebar_3"
                    },
                    {
                      index: "regulatory_settings",
                      name: i18n.t("sage_management.regulatory_settings"),
                      icon_image: "account_sidebar_2"
                    }
                  ];
                } else {
                  return [
                    {
                      index: "inprogress_shops",
                      name: i18n.t("safe_management.inprogress_manage_shop"),
                      icon_image: "safety_sidebar_6"
                    },
                    {
                      index: "early_warning",
                      name: i18n.t("safe_management.early_warning"),
                      icon_image: "log_sidebar_3"
                    },
                    {
                      index: "regulatory_settings",
                      name: i18n.t("sage_management.regulatory_settings"),
                      icon_image: "account_sidebar_2"
                    }
                  ];
                }
              } else {
                return [];
              }
            })(),
            ...(() => {
              if (this.$session.permissions.is("SHOW_ALL_MENUS")) {
                return [
                  {
                    index: "monitor_log",
                    name: i18n.t("safe_management.process_monitor_log"),
                    icon_image: "log_sidebar_5"
                  }
                ];
              } else {
                return [];
              }
            })(),
            ...(() => {
              if (this.$session.permissions.any("SHOW_ALL_MENUS", "IN_PROCESS_MONITORING_APPROVAL")) {
                return [
                  {
                    index: "web_resource_request_list",
                    name: i18n.t("safe_management.request_list"),
                    icon_image: "safety_sidebar_1",
                    sub_menus: [
                      {
                        index: "apply",
                        name: i18n.t("safe_management.wait_pass")
                      },
                      {
                        index: "approve",
                        name: i18n.t("safe_management.team_pass_sidebar")
                      },
                      {
                        index: "reject",
                        name: i18n.t("safe_management.team_refuse_sidebar")
                      }
                    ]
                  }
                ];
              } else {
                return [];
              }
            })()
          ],
          this.$session.permissions.any("SHOW_ALL_MENUS", "IN_PROCESS_MONITORING_SETTING") ? "early_warning" : this.$session.permissions.any("SHOW_ALL_MENUS", "IN_PROCESS_MONITORING_APPROVAL") ? "apply" : "monitor_log",
          [
            ...(() => {
              if (this.$session.permissions.any("SHOW_ALL_MENUS", "IN_PROCESS_MONITORING_APPROVAL")) {
                return ["web_resource_request_list"];
              } else {
                return [];
              }
            })()
          ]
        );
      }
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.default_components = _index.index;
        }
      }
    });
  }
  getSettings() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/regulation-config`);
        this.regulationMode = response.data.regulationMode;
      } catch (error) {
      }
    });
  }
  changeMode(mode) {
    if (mode === "USER") {
      this.regulationMode = "USER";
      this.menu_controller = new MenuController(
        false,
        [
          {
            index: "inprogress_account",
            name: i18n.t("safe_management.inprogress_manage_account"),
            icon_image: "safety_sidebar_6"
          },
          {
            index: "early_warning",
            name: i18n.t("safe_management.early_warning"),
            icon_image: "log_sidebar_3"
          },
          {
            index: "regulatory_settings",
            name: i18n.t("sage_management.regulatory_settings"),
            icon_image: "account_sidebar_2"
          },
          {
            index: "in_process_monitor_log",
            name: i18n.t("safe_management.process_monitor_log"),
            icon_image: "log_sidebar_5"
          },
          {
            index: "web_resource_request_list",
            name: i18n.t("safe_management.request_list"),
            icon_image: "safety_sidebar_1",
            sub_menus: [
              {
                index: "apply",
                name: i18n.t("safe_management.wait_pass")
              },
              {
                index: "approve",
                name: i18n.t("safe_management.team_pass_sidebar")
              },
              {
                index: "reject",
                name: i18n.t("safe_management.team_refuse_sidebar")
              }
            ]
          }
        ],
        "regulatory_settings",
        ["web_resource_request_list"]
      );
    } else {
      this.menu_controller = new MenuController(
        false,
        [
          {
            index: "inprogress_shops",
            name: i18n.t("safe_management.inprogress_manage_shop"),
            icon_image: "safety_sidebar_6"
          },
          {
            index: "early_warning",
            name: i18n.t("safe_management.early_warning"),
            icon_image: "log_sidebar_3"
          },
          {
            index: "regulatory_settings",
            name: i18n.t("sage_management.regulatory_settings"),
            icon_image: "account_sidebar_2"
          },
          {
            index: "in_process_monitor_log",
            name: i18n.t("safe_management.process_monitor_log"),
            icon_image: "log_sidebar_5"
          },
          {
            index: "web_resource_request_list",
            name: i18n.t("safe_management.request_list"),
            icon_image: "safety_sidebar_1",
            sub_menus: [
              {
                index: "apply",
                name: i18n.t("safe_management.wait_pass")
              },
              {
                index: "approve",
                name: i18n.t("safe_management.team_pass_sidebar")
              },
              {
                index: "reject",
                name: i18n.t("safe_management.team_refuse_sidebar")
              }
            ]
          }
        ],
        "regulatory_settings",
        ["web_resource_request_list"]
      );
    }
  }
  changeCollapse() {
    this.mumber_autid_key = UUID.v4();
  }
  changeTeamComponent(data) {
    if (data) {
      this.default_components = data;
    }
  }
};
InprogressManager = __decorateClass([
  Component({
    components: {
      SafeManagement,
      MenuItem,
      MainView,
      UiMenuBar,
      InprogressShops,
      EarlyWarningSettings,
      RegulatorySettings,
      MonitorLog,
      InprogressUser,
      WebResourceRequestList
    }
  })
], InprogressManager);
export {
  InprogressManager as default
};
